import React from "react";

export const FOOTBALL_OPTIONAL_COLUMN_KEYS = new Set([
  "lineType", "primaryMarketLine", "alternateLine", "lineFamilyCount", "goblinAttainability",
  "l5Avg", "l10Avg", "seasonAvg", "l5HitPct", "seasonHitPct", "l5Delta", "l10Delta",
  "seasonDelta", "defenseRank", "defenseFieldSize", "defenseTier", "defenseMetric", "defenseValue", "historySeason",
  "teamContinuity",
]);

export function selectedRegistryColumns(columns, registry, allowedKeys = FOOTBALL_OPTIONAL_COLUMN_KEYS) {
  const selected = new Set((Array.isArray(columns) ? columns : []).filter((column) => column?.visible).map((column) => column.key));
  return (Array.isArray(registry) ? registry : []).filter((definition) => allowedKeys.has(definition.key) && selected.has(definition.key));
}

export function GridOptionalHeaders({ definitions, headerStyle, onSort, arrowFor }) {
  return definitions.map((definition) => (
    <th key={definition.key} data-testid={`grid-header-${definition.key}`} style={{ ...headerStyle, textAlign: definition.align || "left" }} onClick={() => onSort?.(definition.key)}>
      {definition.label} {arrowFor?.(definition.key)}
    </th>
  ));
}

export function GridOptionalCells({ definitions, row, cellStyle }) {
  return definitions.map((definition) => (
    <td key={definition.key} data-testid={`grid-cell-${definition.key}`} style={{ ...cellStyle, textAlign: definition.align || "left" }}>
      {typeof definition.render === "function" ? definition.render(row) : typeof definition.getValue === "function" ? definition.getValue(row) : "—"}
    </td>
  ));
}
